
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "WFNSCOSAH",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/WFNSCOSAH.vue